import { useEffect, useRef, useState } from "react";
import { Functions } from "../../services/firebase/firebase";
import { useCurrentPersonIds } from "../../context/UserContext";
import { IPersonName } from "@styreportalen/common";

export type PersonInfo = {
  org_id: string;
  document_id: string;
  org_name?: string;
  name: IPersonName;
  federation?: string;
};

export const useUserPersons = (
  page: "startpage" | "select" | "oauth",
  refetch = false
) => {
  const personIds = useCurrentPersonIds();
  const [selectablePersons, setSelectablePersons] = useState<
    PersonInfo[] | null
  >();

  const reFetched = useRef(refetch);

  useEffect(() => {
    (async () => {
      if (
        (personIds && personIds.length > 1 && page === "select") ||
        reFetched.current ||
          page === "oauth"
      )
        await Functions.httpsCallable("tutti-web-getUserPersons")()
          .then((response) => {
            setSelectablePersons(response.data);
          })
          .catch(() => setSelectablePersons(undefined));
    })();

    return () => {
      reFetched.current = false;
    };
  }, [refetch, personIds, page]);

  return selectablePersons;
};
